import React, { useState } from 'react'
import { Icon } from 'meinian-package/src/component'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({ label, labelIcon, style, options, contentStyle, onChange, displayTextClassName }) => {
  const [visible, setVisible] = useState(false)
  const content = (<div className={styles.toolSelectContent} contentStyle={contentStyle}>
    {options.map(item => <div
      className={classNames('toolSelectContentItem', { disabled: item.disabled })}
      onClick={() => {
        if (!item.disabled) {
          setVisible(false)
          onChange(item.value, item)
        }
      }}
    >{item.label}</div>)}
  </div>)
  return <Dropdown
    placement="bottomRight"
    trigger="click"
    overlay={content}
    open={visible}
    onOpenChange={vis => setVisible(vis)}
  >
    <div className={classNames(styles.toolSelect, displayTextClassName)} style={style}>
      <div className="toolSelectLabelWrap">
        <Icon type={labelIcon} className="toolSelectLabelIcon" />
        <div className="toolSelectLabel">{label}</div>
      </div>
    </div>
  </Dropdown>
}
